import React, { Component } from 'react';
import { Table, Row, InputNumber } from 'antd';
import Compared from "../../Compared";


Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            data: [],
            loading: true,
            note: { note: "" },
            note8_2: { comments: "" },
            loadingSave: false,
            print: false
        }
    }

    onChange = (name, value, i) => {
        let data = this.props.data;
        data[i][name] = value;

        this.props.onChange('data8_1_2', data);
    }

    render() {
        const data = this.props.data;
        const columns = [{
            title: 'Utility Item 能源项目',
            dataIndex: 'utility_item',
            key: 'utility_item',
            align: "center",
            fixed: "left",
            width: 400,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding`} style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: text || "-" }}>

                    </div>
                )
            }
        }, {
            title: 'Current Month 本年当月',
            align: "center",
            children: [{
                align: "center",
                title: 'Current Month Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_thisyear_consumption',
                    key: 'cma_thisyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Consumption 消耗量'];
                        // 人数单独两列
                        if (index == 2) {
                            return {
                                children: <Compared data={{ index, key: 'cma_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding `}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>,
                                props: {
                                    colSpan: 3
                                }
                            }
                        }

                        if (index >= 0 && index < 2) {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_thisyear_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_thisyear_average',
                    key: 'cma_thisyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Average Unit Price 平均单价'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <Compared data={{ index, key: 'cma_thisyear_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_thisyear_cost',
                    key: 'cma_thisyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Cost 成本费用'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        if (index == 4 || index == 3) {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_thisyear_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Last Month Actual - Current Year 本年上月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_consumption',
                    key: 'cma_lastyear_lastmonth_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Consumption 消耗量'];
                        // 人数单独两列
                        if (index == 2) {
                            return {
                                children: <Compared data={{ index, key: 'cma_lastyear_lastmonth_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding `}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>,
                                props: {
                                    colSpan: 3
                                }
                            }
                        }
                        if (index >= 0 && index <= 2) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_lastmonth_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_average',
                    key: 'cma_lastyear_lastmonth_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Average Unit Price 平均单价'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <Compared data={{ index, key: 'cma_lastyear_lastmonth_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_cost',
                    key: 'cma_lastyear_lastmonth_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Cost 成本费用'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        if (index == 4 || index == 3) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_lastmonth_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_lastyear_consumption',
                    key: 'cma_lastyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Consumption 消耗量'];
                        // 人数单独两列
                        if (index == 2) {
                            return {
                                children: <Compared data={{ index, key: 'cma_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding `}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>,
                                props: {
                                    colSpan: 3
                                }
                            }
                        }
                        if (index >= 0 && index <= 2) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_lastyear_average',
                    key: 'cma_lastyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Average Unit Price 平均单价'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <Compared data={{ index, key: 'cma_lastyear_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_lastyear_cost',
                    key: 'cma_lastyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Cost 成本费用'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        if (index == 4 || index == 3) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'cmv_comparison_consumption',
                    key: 'cmv_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding `} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_consumption_percent',
                    key: 'cmv_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_consumption_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'cmv_comparison_average',
                    key: 'cmv_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_average_percent',
                    align: "center",
                    key: 'cmv_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_average_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'cmv_comparison_cost',
                    key: 'cmv_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_cost_percent',
                    key: 'cmv_comparison_cost_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_cost_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding `} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 1650,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 年累计实际 - 今年',
                width: 450,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'ytda_thisyear_consumption',
                    key: 'ytda_thisyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Consumption 消耗量'];
                        // 人数单独两列
                        if (index == 2) {
                            return {
                                children: <Compared data={{ index, key: 'ytda_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding `}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>,
                                props: {
                                    colSpan: 3
                                }
                            }
                        }
                        if (index >= 0 && index <= 2) {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_thisyear_consumption', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytda_thisyear_average',
                    key: 'ytda_thisyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Average Unit Price 平均单价'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <Compared data={{ index, key: 'ytda_thisyear_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytda_thisyear_cost',
                    key: 'ytda_thisyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Cost 成本费用'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        if (index == 4 || index == 3) {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_thisyear_cost', value, index)
                                            }}
                                            onCha
                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 年累计实际 - 去年',
                width: 450,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'ytda_lastyear_consumption',
                    key: 'ytda_lastyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Consumption 消耗量'];
                        // 人数单独两列
                        if (index == 2) {
                            return {
                                children: <Compared data={{ index, key: 'ytda_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding `}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>,
                                props: {
                                    colSpan: 3
                                }
                            }
                        }
                        if (index >= 0 && index <= 2) {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_lastyear_consumption', value, index)
                                            }}
                                            onCha
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytda_lastyear_average',
                    key: 'ytda_lastyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Average Unit Price 平均单价'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <Compared data={{ index, key: 'ytda_lastyear_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytda_lastyear_cost',
                    key: 'ytda_lastyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Cost 成本费用'];
                        if (index == 2) {
                            return {
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        if (index == 4 || index == 3) {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className={`table-padding`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_lastyear_cost', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月',
                width: 750,
                children: [{
                    title: <div>Consumption <br />消耗量</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_consumption',
                    key: 'ytdv_lastmonth_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding `} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_consumption_percent',
                    key: 'ytdv_lastmonth_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_consumption_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_average',
                    key: 'ytdv_lastmonth_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_average_percent',
                    align: "center",
                    key: 'ytdv_lastmonth_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_average_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_cost',
                    key: 'ytdv_lastmonth_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_cost_percent',
                    align: "center",
                    key: 'ytdv_lastmonth_comparison_cost_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_cost_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 750,
                children: [{
                    title: <div>Consumption <br />消耗量</div>,
                    dataIndex: 'ytdv_comparison_consumption',
                    key: 'ytdv_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_consumption', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding `} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_consumption_percent',
                    key: 'ytdv_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_consumption_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytdv_comparison_average',
                    key: 'ytdv_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_average', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_average_percent',
                    align: "center",
                    key: 'ytdv_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_average_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytdv_comparison_cost',
                    key: 'ytdv_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_cost', title, sqlName: "_8_1_2", name: record.name, type: 'number' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_cost_percent',
                    align: "center",
                    key: 'ytdv_comparison_cost_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_cost_percent', title, sqlName: "_8_1_2", name: record.name, type: 'percent' }}>
                                <div className={`table-padding`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }];
        return (
            <div style={{ margin: "20px 0" }}>
                <Row style={{ width: this.props.print ? 5400 : 'auto' }}>
                    <Row>8.1.2  Energy Consumption - Guestroom Area  客房区域能耗统计</Row>

                    <Table
                        columns={columns}
                        dataSource={data}
                        size="middle"
                        bordered
                        pagination={false}
                        className="content"
                        style={{ width: this.props.print ? 5350 : 'auto' }}
                        scroll={this.props.print ? {} : { x: 5350 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/8.0/8-1/8-1-2.js